export default __webpack_public_path__ + "static/media/groceries.a0e37126.png";